import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import settlement from '@/store/settlement'
import script from '@/store/script'
import scriptGroup from '@/store/script-group'
import calendarEventEditing from '@/store/calendar-event-editing'
import customers from '@/store/customers'
import organization from '@/store/organization'
import organizationConfig from '@/store/organization-config'
import publicStore from '@/store/publicStore'
import user from '@/store/user'
import calendar from './calendar'
import service from './service'
import customer from './customer'
import auth from './auth'
import verticalMenu from './vertical-menu'
import attachment from './attachment'
import appConfig from './app-config'
import app from './app'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    attachment,
    verticalMenu,
    auth,
    customer,
    service,
    calendar,
    settlement,
    script,
    scriptGroup,
    calendarEventEditing,
    organization,
    organizationConfig,
    publicStore,
    user,

    customers,
  },
  strict: process.env.DEV,
})
